/* select2 implementation removed */
import dispatchSelectLoaded from './utils/dispatch_select_loaded'

$(document).ready(() => $('.select_driven').each(function () {
  const select_element = $(this);
  const select_value_element = select_element.closest('.select-value');
  const use_empty_option = !select_value_element.data('prohibitEmptyOption')
  const selected_value = select_value_element.data('selectedValue')
  const railsEvn = document.body.dataset.railsEnv

  return $.ajax({
    url: select_element.data('select-source'),
    type: 'GET',
    dataType: 'json',
    success(returnedData) {
      if (railsEvn !== 'test' && use_empty_option) {
        select_element.append($('<option>', {
          value: '',
          text: '-'
        }));
      }
      returnedData.forEach(element => {
        select_element.append($('<option>', {
          value: element.id,
          text: element.text
        }));
      })
      if (selected_value) {
        select_element.val(selected_value);
      }

      /** If we use SelectSearchController,
       * we must send it select:loaded event to create an instance.
       */
      dispatchSelectLoaded(select_element[0])
    }
  });
}));
